// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"d0a09068","148":"4cd0a34e","360":"902482cd","398":"bb8974aa","631":"f93f2274","857":"af78f376","868":"a46853a4"}[chunkId] + ".chunk.js";
};